import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { BaseDAO } from './baseDAO';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VesselSplitRate } from 'anchor-shared/lib/model/entity/vesselSplitRate';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class VesselSplitRateDAO extends BaseDAO<VesselSplitRate> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.VESSEL_SPLIT_RATE);
  }

  public createMultiple(
    vesselId: number,
    newSplitRates: VesselSplitRate[],
  ): Observable<boolean[]> {
    let url: string = `${this.apiHelper.getServiceName()}${this.getResource()}/${vesselId}/create-multiple`;
    let method = 'POST';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(
      url,
      method,
      null,
      newSplitRates,
      headers,
      null,
    );
  }

  public updateMultiple(
    vesselId: number,
    splitRates: VesselSplitRate[],
  ): Observable<boolean[]> {
    let url: string = `${this.apiHelper.getServiceName()}${this.getResource()}/${vesselId}/update-multiple`;
    let method = 'PUT';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(
      url,
      method,
      null,
      splitRates,
      headers,
      null,
    );
  }

  public deleteMultiple(
    vesselId: number,
    vesselRateId: number,
  ): Observable<any> {
    let url: string = `${this.apiHelper.getServiceName()}${this.getResource()}/${vesselId}/delete-multiple`;
    let method = 'DELETE';
    let data = {
      vesselRateId: vesselRateId,
    };
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, method, null, data, headers, null);
  }
}
